import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/team/importer/teamImporterActions';

export default importerReducers(actions);
